import { gql } from "@apollo/client";

const PENDINGCHATCOUNTCHANGEDSUBSCRIPTION = gql`
  subscription pendingchatcountchanged {
    pendingchatcountchanged {
      success
      error
      result
    }
  }
`;
export default PENDINGCHATCOUNTCHANGEDSUBSCRIPTION;
